import Phaser from 'phaser';

/**
 * Fill a 5-point star into the given Graphics object — no stroke, semi-
 * transparent. Used by the cream-backdrop scenes (Home, Result) to sprinkle
 * yolk + coral stars in the margins so the wide blank canvas reads as
 * intentional decoration instead of empty space. Sharp inner valleys keep
 * the silhouette punchy at small radii.
 */
export function fillBackdropStar(
  g: Phaser.GameObjects.Graphics,
  cx: number,
  cy: number,
  r: number,
  color: number,
  alpha: number,
) {
  const inner = r * 0.45;
  g.fillStyle(color, alpha);
  g.beginPath();
  for (let i = 0; i < 10; i++) {
    const angle = (Math.PI * 2 * i) / 10 - Math.PI / 2;
    const radius = i % 2 === 0 ? r : inner;
    const x = cx + Math.cos(angle) * radius;
    const y = cy + Math.sin(angle) * radius;
    if (i === 0) g.moveTo(x, y);
    else g.lineTo(x, y);
  }
  g.closePath();
  g.fillPath();
}
